var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportConvert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ReportConvert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ReportConvert",
    transform: "translate(0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(2.000000, 2.000000)",
    fill: "#677283"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0900879,0 C19.2285156,0 20.0900879,0.935668945 20.0900879,2 L20.0900879,18 C20.0900879,19.1 19.1900879,20 18.0900879,20 L10.0778809,20 L10.0788809,18 L18.0900879,18 L18.0900879,2 L10.0868809,2 L10.0878809,0 L18.0900879,0 Z M5.97277832,0 C7.11120605,0 7.97277832,0.935668945 7.97277832,2 L7.972,9 L11.0138939,9 L9.61919593,7.4142136 L11.0334095,6 L14.8441075,10 L11.0334095,14 L9.61919593,12.5857864 L11.0158939,11 L7.972,11 L7.97277832,18 C7.97277832,19.1 7.07277832,20 5.97277832,20 L0,20 L0,18 L5.97277832,18 L5.972,11 L2,11 L2,9 L5.972,9 L5.97277832,2 L0,2 L0,0 L5.97277832,0 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportConvert);
export default __webpack_public_path__ + "static/media/ReportConvert.c53cde66f324a4a93b75627ba0e6045e.svg";
export { ForwardRef as ReactComponent };